import { c as _c } from "react/compiler-runtime";
import { mapUnion } from '@funkey/shared';
import { cx } from 'class-variance-authority';
import { Button, FormInputErrors, Icon } from '~/components/primitives';
import { useI18n } from '~/features/i18n';
import useNotifications from '~/features/notifications/useNotifications';
import { useStateObject } from '~/utils/react';
import { action_validateVoucherCode } from './actions';
export const VoucherCodeField: React.FC<{
  /** Voucher Code */
  value: string | null;
  /** Gets called when the voucher code is successfully validated or set to null */
  onChange: (voucherCode: string | null) => void;
  className?: string;
}> = props => {
  const $ = _c(33);
  const i18n = useI18n();
  const isOpen = useStateObject(false);
  const voucherCodeInput = useStateObject(props.value ?? "");
  const notifications = useNotifications();
  const errorMessage = useStateObject(null);
  const status = errorMessage.value ? "error" : props.value ? "success" : "pending";
  const t0 = isOpen.value && "rounded-2xl border p-4";
  let t1;
  if ($[0] !== props.className || $[1] !== status || $[2] !== t0) {
    t1 = cx("flex flex-col gap-4 border-current transition-all", t0, mapUnion(status, {
      "text-blue-200": "pending",
      "text-secondary": "success",
      "text-tertiary": "error"
    }), props.className);
    $[0] = props.className;
    $[1] = status;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = props.value ? "text-secondary" : "text-tertiary";
  let t3;
  if ($[4] !== t2) {
    t3 = cx("group flex items-center gap-2 leading-none transition-all", t2);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isOpen || $[7] !== props) {
    t4 = () => isOpen.set(prev => {
      if (prev === true) {
        props.onChange(null);
      }
      return !prev;
    });
    $[6] = isOpen;
    $[7] = props;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Icon name="gift" className="h-6 w-6" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== i18n) {
    t6 = i18n._("I have a voucher or discount code");
    $[10] = i18n;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <span className="group-hover:underline">{t6}</span>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isOpen.value || $[15] !== props.value) {
    t8 = isOpen.value && (props.value ? <Icon name="check-circle-1" className="ml-auto" strokeWidth={0.7} /> : <Icon name="close" size="sm" className="ml-auto" strokeWidth={1.8} />);
    $[14] = isOpen.value;
    $[15] = props.value;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t3 || $[18] !== t4 || $[19] !== t7 || $[20] !== t8) {
    t9 = <button type="button" className={t3} onClick={t4}>{t5}{t7}{t8}</button>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== errorMessage || $[23] !== i18n || $[24] !== isOpen.value || $[25] !== notifications || $[26] !== props || $[27] !== voucherCodeInput) {
    t10 = isOpen.value && <div><label className="flex items-center gap-2 rounded-4xl border border-blue-200 px-3 py-2" htmlFor="voucher"><input className="h-11 w-full appearance-none rounded-4xl border-0 border-none bg-transparent py-0 text-primary placeholder:text-blue-200 focus:ring-0" name="voucher" value={voucherCodeInput.value} autoFocus={true} placeholder="CODE-1234" onChange={e => voucherCodeInput.set(e.currentTarget.value)} style={{
          boxShadow: "none !important"
        }} readOnly={!!props.value} />{!props.value ? <Button variant="tertiary" disabled={voucherCodeInput.value.length === 0} onClick={async () => {
          ;
          try {
            const validation = await action_validateVoucherCode(voucherCodeInput.value);
            if (validation.ok) {
              errorMessage.set(null);
              props.onChange(validation.voucherCode);
            } else {
              errorMessage.set(i18n._("Invalid voucher code"));
              props.onChange(null);
            }
          } catch (t11) {
            notifications.dispatchError({
              message: i18n._("Failed to validate voucher")
            });
          }
        }}>{i18n._("Validate")}</Button> : <button type="button" title={i18n._("Delete")} onClick={() => props.onChange(null)}><Icon name="close" className="text-tertiary" strokeWidth={1.8} /></button>}</label>{errorMessage.value && <FormInputErrors className="ml-1 mt-4" errors={[errorMessage.value]} />}</div>;
    $[22] = errorMessage;
    $[23] = i18n;
    $[24] = isOpen.value;
    $[25] = notifications;
    $[26] = props;
    $[27] = voucherCodeInput;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t1 || $[30] !== t10 || $[31] !== t9) {
    t11 = <section className={t1}>{t9}{t10}</section>;
    $[29] = t1;
    $[30] = t10;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
};